'use client';

import { TextLink } from '@/components/TextLink';
import { IconArrowLeft } from '@/components/icons';
import { SubStepOpts } from '../../PictureStep';

// SubSteps content
import { UploadPhoto } from '../UploadPhoto';
import { SystemTypeLocationSizeSubStep } from '../SystemTypeLocationSizeSubStep';
import { SystemModelNumberLocationSubStep } from '../SystemModelNumberLocationSubStep';

export interface SubStepsWrapperProps {
	testId?: string;
	handleClick: (show: SubStepOpts) => void;
	showComponent: SubStepOpts;
}

const SubStepsWrapper = (props: SubStepsWrapperProps) => {
	const { testId = 'SubStepsWrapper', handleClick, showComponent } = props;

	return (
		<>
			<div className="absolute left-4 top-0 lg:left-6 2xl:left-0">
				<TextLink
					iconRender={() => (
						<IconArrowLeft className="mr-1 h-3 w-4 fill-sky-700 group-hover:fill-sky-800" />
					)}
					iconPosition="left"
					onClick={() => handleClick('default')}
				>
					<div className="text-sky-700 group-hover:text-sky-800">
						Other options
					</div>
				</TextLink>
			</div>
			<div data-testid={testId} className="mb-8 mt-10 lg:mb-10 lg:mt-20">
				{showComponent === 'upload' && <UploadPhoto />}
				{showComponent === 'type-size' && <SystemTypeLocationSizeSubStep />}
				{showComponent === 'model-number' && (
					<SystemModelNumberLocationSubStep />
				)}
			</div>
		</>
	);
};

export default SubStepsWrapper;
